module.exports = __webpack_public_path__ + "img/blueModalPic.218b4ef6.svg";